import { useEffect } from 'react';
import { useContactModal, usePrivatePolicyModal } from './useContactModal';

export const useForbidScroll = () => {
  const { isPrivatePolicyModalOpen } = usePrivatePolicyModal();
  const { isContactModalOpen } = useContactModal();
  useEffect(() => {
    if (isPrivatePolicyModalOpen || isContactModalOpen)
      document.body.style.overflowY = 'hidden';
    else document.body.style.overflowY = 'unset';
  }, [isPrivatePolicyModalOpen, isContactModalOpen]);
};
